/* eslint-disable no-case-declarations */
import {
  CREATE_SENDING_REQUESTED,
  CREATE_SENDING_OK,
  CREATE_SENDING_FAIL,
  LOAD_SENDINGS_REQUESTED,
  LOAD_SENDINGS_OK,
  LOAD_SENDINGS_FAIL,
  COPY_SENDING,
  CREATE_SENDING_CLICK,
  START_SENDING_FAIL,
  START_SENDING_OK,
  START_SENDING_REQUESTED,
  PAUSE_SENDING_FAIL,
  PAUSE_SENDING_OK,
  PAUSE_SENDING_REQUESTED,
  VIEW_SENDING,
  EDIT_DRAFT_SENDING,
  UPDATE_SENDING_REQUESTED,
  UPDATE_SENDING_OK,
  UPDATE_SENDING_FAIL,
} from "actions/sendings";
import {
  FLAGS_SENDING_FAIL,
  FLAGS_SENDING_OK,
  FLAGS_SENDING_REQUESTED,
} from "../actions/sendings";

const INITIAL_STATE = {
  loading: false,
  data: {},
  loadData: [],
  copyData: null,
  viewData: null,
  editData: null,
  errors: {},
  isSuccessCreating: false,
  isSuccessUpdating: false,
  isEdit: false,
  isCopy: false,
  count: null,
  stats: {},
};

export function sendingsReducer(state = INITIAL_STATE, action) {
  const oldLoadData = state.loadData;
  const oldViewData = state.viewData;

  switch (action.type) {
    case CREATE_SENDING_REQUESTED:
      return {
        ...INITIAL_STATE,
        loading: true,
      };

    case CREATE_SENDING_OK:
      return {
        ...INITIAL_STATE,
        loading: false,
        data: action.data,
        isSuccessCreating: true,
      };

    case CREATE_SENDING_FAIL:
      return {
        ...INITIAL_STATE,
        loading: false,
        errors: action.errors,
      };

    case UPDATE_SENDING_REQUESTED:
      return {
        ...INITIAL_STATE,
        loading: true,
        isSuccessUpdating: false,
        isEdit: true,
        isCopy: false,
      };

    case UPDATE_SENDING_OK:
      return {
        ...INITIAL_STATE,
        loading: false,
        data: action.data,
        isSuccessUpdating: true,
        isEdit: false,
        isCopy: false,
      };

    case UPDATE_SENDING_FAIL:
      return {
        ...INITIAL_STATE,
        loading: false,
        errors: action.errors,
        isSuccessUpdating: true,
        isEdit: false,
        isCopy: false,
      };

    case FLAGS_SENDING_REQUESTED:
      return {
        ...state,
        loading: true,
        isSuccessUpdating: false,
      };

    case FLAGS_SENDING_OK:
      return {
        ...state,
        data: action.data,
        isSuccessUpdating: true,
        loading: false,
      };

    case FLAGS_SENDING_FAIL:
      return {
        ...state,
        errors: action.errors,
        isSuccessUpdating: true,
      };

    case LOAD_SENDINGS_REQUESTED:
      return {
        ...state,
        loading: true,
        // isEdit: false,
      };

    case LOAD_SENDINGS_OK:
      return {
        loading: false,
        loadData: (action.data.result?.length && action.data.result) || [],
        count: action.data.count,
        stats: action.data.stats,
        isEdit: false,
        isCopy: false,
      };

    case LOAD_SENDINGS_FAIL:
      return {
        ...INITIAL_STATE,
        loading: false,
        errors: action.errors,
      };

    case START_SENDING_REQUESTED:
      return {
        loadData: state.loadData,
        viewData: oldViewData,
        loading: true,
        isEdit: false,
        isCopy: false,
      };

    case START_SENDING_OK:
      for (let i = 0; i < oldLoadData?.length; i += 1) {
        if (oldLoadData[i].mailing.id === action.mailingId) {
          oldLoadData[i].mailing.status = action.mailingStatus;
          oldLoadData[i].mailing_stats.start_date = action.startDate;
        }
      }
      if (
        oldViewData &&
        oldViewData.mailing &&
        oldViewData.mailing.id === action.mailingId
      ) {
        oldViewData.mailing.status = action.mailingStatus;
        oldViewData.mailing_stats.start_date = action.startDate;
      }

      return {
        loading: false,
        isEdit: false,
        isCopy: false,
        loadData: oldLoadData,
        viewData: oldViewData,
      };

    case START_SENDING_FAIL:
      return {
        loading: false,
        isEdit: false,
        isCopy: false,
        loadData: state.loadData,
        viewData: oldViewData,
        errors: action.errors,
      };

    case PAUSE_SENDING_REQUESTED:
      return {
        loading: true,
        isEdit: false,
        isCopy: false,
        loadData: state.loadData,
        viewData: oldViewData,
      };

    case PAUSE_SENDING_OK:
      for (let i = 0; i < oldLoadData?.length; i += 1) {
        if (oldLoadData[i].mailing.id === action.mailingId) {
          oldLoadData[i].mailing.status = action.mailingStatus;
        }
      }
      if (
        oldViewData &&
        oldViewData.mailing &&
        oldViewData.mailing.id === action.mailingId
      ) {
        oldViewData.mailing.status = action.mailingStatus;
      }

      return {
        loading: false,
        isEdit: false,
        isCopy: false,
        loadData: state.loadData,
        viewData: oldViewData,
      };

    case PAUSE_SENDING_FAIL:
      return {
        loading: false,
        isEdit: false,
        isCopy: false,
        loadData: state.loadData,
        viewData: oldViewData,
        errors: action.errors,
      };

    case COPY_SENDING:
      return {
        ...state,
        loading: false,
        isEdit: false,
        isCopy: true,
        copyData: action.copyData,
      };

    case CREATE_SENDING_CLICK:
      return {
        ...INITIAL_STATE,
        loading: false,
      };

    case VIEW_SENDING:
      return {
        ...state,
        loading: false,
        isEdit: false,
        isCopy: false,
        viewData: action.viewData,
      };

    case EDIT_DRAFT_SENDING:
      return {
        ...state,
        loading: false,
        isEdit: true,
        isCopy: false,
        editData: action.editData,
      };

    default:
      return state;
  }
}
